import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow
} from '@material-ui/core';
import { useStyles } from '../styles';
import PatientActivityTableRow from './PatientActivityTableRow';


const PatientActivityTable = ({
  data,
  selectedTab,
  headTableCells
}) => {
  const { userStoreData: {storeCode} } = useSelector((state: IReduxState) => state.user);
  const isCustomer3 = storeCode === 'customer3';
  const classes = useStyles();
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (_, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  return (
    <>
      <div className="table-container">
        <TableContainer component={Paper}>
          <Table aria-label="collapsible table" className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox" />
                {headTableCells?.map((cell, index) => {
                  if (!cell.display) {
                    return null;
                  }

                  return (
                    <TableCell
                      key={index}
                      align="center"
                      className={`min-w-${cell.width}`}
                    >
                      {cell.label}
                    </TableCell>
                  );
                })}
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {!data?.length ?
                <TableRow>
                  <TableCell colSpan={Object.keys(headTableCells)?.length + 1} align="center">
                    {`No matching ${isCustomer3 ? 'customer' : 'patient'} activity found.`}
                  </TableCell>
                </TableRow>
                :
                data.slice(currentPage * rowsPerPage, (currentPage * rowsPerPage) + rowsPerPage).map((quote) => (
                  <PatientActivityTableRow
                    key={quote._id}
                    quote={quote}
                    selectedTab={selectedTab}
                    headTableCells={headTableCells}
                  />
                ))
              }
            </TableBody>
          </Table>
        </TableContainer>
        {!!data?.length &&
          <TablePagination
            rowsPerPageOptions={[10, 20, 40, 80, 100]}
            component="div"
            className={classes.paginationContainer}
            count={data.length}
            rowsPerPage={rowsPerPage}
            page={currentPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        }
      </div>
    </>
  );
};

export default PatientActivityTable;
